"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _lodash = require("lodash");

var _SearchComponentContainer = _interopRequireDefault(require("../../searchcomponent/containers/SearchComponentContainer"));

var _SelectedConfigurationDisplay = _interopRequireDefault(require("./SelectedConfigurationDisplay"));

var _FulfillmentConfigurationListContainer = _interopRequireDefault(require("../../fulfillmentconfigurationlist/containers/FulfillmentConfigurationListContainer"));

var _VersionsListContainer = _interopRequireDefault(require("../../versionslist/containers/VersionsListContainer"));

var _FulfillmentConfigurationErrorPage = _interopRequireDefault(require("../../shared/FulfillmentConfigurationErrorPage"));

var _sharedtypes = require("../../shared/sharedtypes");

/* eslint-disable complexity */
// eslint-disable-next-line max-len
var ComponentShell = function ComponentShell(props) {
  var showVersions = props.showVersions,
      selectedFulfillmentConfiguration = props.selectedFulfillmentConfiguration,
      availableFulfillmentConfigurations = props.availableFulfillmentConfigurations,
      loadFulfillmentConfigurations = props.loadFulfillmentConfigurations,
      loadVersions = props.loadVersions,
      clearSelectedFulfillmentConfiguration = props.clearSelectedFulfillmentConfiguration,
      showFulfillmentConfigurationsList = props.showFulfillmentConfigurationsList,
      clearSelectedVersion = props.clearSelectedVersion,
      setEnvironment = props.setEnvironment,
      getFulfillmentConfigurationDetails = props.getFulfillmentConfigurationDetails,
      selectFulfillmentConfiguration = props.selectFulfillmentConfiguration,
      selectVersion = props.selectVersion,
      showVersionsList = props.showVersionsList,
      incompletePropsMessage = props.incompletePropsMessage,
      language = props.language,
      buyerAccountId = props.buyerAccountId,
      productConfigurationUrl = props.productConfigurationUrl,
      onFulfillmentConfigurationSelected = props.onFulfillmentConfigurationSelected,
      initialFulfillmentConfigurationUrl = props.initialFulfillmentConfigurationUrl;

  var _useTranslation = (0, _reactI18next.useTranslation)('shell'),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var initializeWithFulfillmentConfiguration = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var fulfillmentConfigurationList, _yield$getFulfillment, requestedInitialFulfillmentConfiguration, requestedInitialVersion, requestedFulfillmentConfigurationId;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return loadFulfillmentConfigurations();

            case 2:
              fulfillmentConfigurationList = _context.sent;
              _context.next = 5;
              return getFulfillmentConfigurationDetails();

            case 5:
              _yield$getFulfillment = _context.sent;
              requestedInitialFulfillmentConfiguration = _yield$getFulfillment.requestedInitialFulfillmentConfiguration;
              requestedInitialVersion = _yield$getFulfillment.requestedInitialVersion;

              if (requestedInitialFulfillmentConfiguration) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              requestedFulfillmentConfigurationId = requestedInitialFulfillmentConfiguration.fulfillmentConfigurationId;

              if (!(0, _lodash.find)(fulfillmentConfigurationList, function (_ref2) {
                var fulfillmentConfigurationId = _ref2.fulfillmentConfigurationId;
                return fulfillmentConfigurationId === requestedFulfillmentConfigurationId;
              })) {
                _context.next = 18;
                break;
              }

              selectFulfillmentConfiguration(requestedInitialFulfillmentConfiguration);
              _context.next = 15;
              return loadVersions({
                fulfillmentConfigurationId: requestedFulfillmentConfigurationId
              });

            case 15:
              selectVersion(requestedInitialVersion);
              showVersionsList();
              onFulfillmentConfigurationSelected({
                fulfillmentConfigurationUrl: initialFulfillmentConfigurationUrl
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function initializeWithFulfillmentConfiguration() {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    // Pass along the external environment prop to the Redux store
    setEnvironment();
  }, []);
  (0, _react.useEffect)(function () {
    // If a language prop is passed in, update the component's displayed language to match
    i18n.changeLanguage(language);
  }, [language]);
  (0, _react.useEffect)(function () {
    var initialLoading = function initialLoading() {
      clearSelectedFulfillmentConfiguration();
      clearSelectedVersion();
      showFulfillmentConfigurationsList();
      onFulfillmentConfigurationSelected({
        fulfillmentConfigurationUrl: ''
      });

      if (productConfigurationUrl && buyerAccountId) {
        if (initialFulfillmentConfigurationUrl) {
          initializeWithFulfillmentConfiguration();
        } else {
          loadFulfillmentConfigurations();
        }
      }
    };

    initialLoading();
  }, [productConfigurationUrl, buyerAccountId]);
  var selectedConfigurationDisplay = availableFulfillmentConfigurations.length !== 0 ? /*#__PURE__*/_react["default"].createElement(_SelectedConfigurationDisplay["default"], {
    selectedFulfillmentConfiguration: selectedFulfillmentConfiguration,
    availableFulfillmentConfigurations: availableFulfillmentConfigurations,
    clearSelectedFulfillmentConfiguration: clearSelectedFulfillmentConfiguration,
    showFulfillmentConfigurationsList: showFulfillmentConfigurationsList,
    clearSelectedVersion: clearSelectedVersion,
    onFulfillmentConfigurationSelected: onFulfillmentConfigurationSelected
  }) : null;
  var visibleListComponent;

  if (!productConfigurationUrl || !buyerAccountId) {
    visibleListComponent = /*#__PURE__*/_react["default"].createElement(_FulfillmentConfigurationErrorPage["default"], {
      loadFulfillmentConfigurations: loadFulfillmentConfigurations,
      errorMessage: incompletePropsMessage || t('incompletePropsMessage'),
      errorStyle: "warning",
      showReload: false
    });
  } else if (showVersions) {
    visibleListComponent = /*#__PURE__*/_react["default"].createElement(_VersionsListContainer["default"], props);
  } else {
    visibleListComponent = /*#__PURE__*/_react["default"].createElement(_FulfillmentConfigurationListContainer["default"], props);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-componentShell"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "fcp-componentShell__title"
  }, t('componentTitle')), /*#__PURE__*/_react["default"].createElement(_SearchComponentContainer["default"], null), selectedConfigurationDisplay, /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-componentShell__body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-componentShellBody__inner"
  }, visibleListComponent)));
};

ComponentShell.propTypes = {
  showVersions: _propTypes["default"].bool.isRequired,
  availableFulfillmentConfigurations: _propTypes["default"].arrayOf(_sharedtypes.FulfillmentConfiguration).isRequired,
  selectedFulfillmentConfiguration: _sharedtypes.FulfillmentConfiguration,
  loadFulfillmentConfigurations: _propTypes["default"].func.isRequired,
  loadVersions: _propTypes["default"].func.isRequired,
  clearSelectedFulfillmentConfiguration: _propTypes["default"].func.isRequired,
  showFulfillmentConfigurationsList: _propTypes["default"].func.isRequired,
  clearSelectedVersion: _propTypes["default"].func.isRequired,
  setEnvironment: _propTypes["default"].func.isRequired,
  getFulfillmentConfigurationDetails: _propTypes["default"].func.isRequired,
  selectFulfillmentConfiguration: _propTypes["default"].func.isRequired,
  selectVersion: _propTypes["default"].func.isRequired,
  showVersionsList: _propTypes["default"].func.isRequired,
  incompletePropsMessage: _propTypes["default"].string,
  language: _propTypes["default"].string,
  buyerAccountId: _propTypes["default"].string.isRequired,
  productConfigurationUrl: _propTypes["default"].string.isRequired,
  onFulfillmentConfigurationSelected: _propTypes["default"].func,
  initialFulfillmentConfigurationUrl: _propTypes["default"].string
};
ComponentShell.defaultProps = {
  selectedFulfillmentConfiguration: undefined,
  incompletePropsMessage: undefined,
  language: 'en',
  onFulfillmentConfigurationSelected: function onFulfillmentConfigurationSelected() {},
  initialFulfillmentConfigurationUrl: undefined
};
var _default = ComponentShell;
exports["default"] = _default;